var r=9,a="9+";export{r as NotificationCountDisplayCap,a as NotificationCountDisplayCapText};
